import React, { useState } from "react";
import styles from "./CategoryCreateSelectModal.module.css";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AxiosUrl from "../AxiosUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CategoryCreateSelectModal({ setOpenCategoryModal, setRefresh }) {
  const [Name, setName] = useState("");
  const [loading, setloading] = useState(false);

  const uid = localStorage.getItem("id");

  const fromData = {
    uid,
    Name,
  };

  const SubmitData = () => {
    if (!Name || Name.trim() === "") {
      toast.error("Please enter a category name");
      return;
    }
    setloading(true);
    AxiosUrl.post(`/home-create-category`, fromData)
      .then((data) => {
        setloading(false);
        if (data.data === "HomeCategory Limit 3") {
          toast.error("Home Category Limit Reached (Maximum 3)");
        }
        if (data.data === "HomeCategory Successful") {
          toast.success("Home Category created successfully!");
          setOpenCategoryModal(false);
          if (setRefresh) {
            setRefresh((prev) => prev + 1);
          }
        }
      })
      .catch((error) => {
        setloading(false);
        toast.error("Failed to create home category");
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      SubmitData();
    }
  };

  return (
    <div className={styles.modalBackground}>
      <ToastContainer />
      <div className={styles.modalContainer}>
        <div className={styles.titleCloseBtn}>
          <button
            onClick={() => setOpenCategoryModal(false)}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#f3f4f6',
              border: 'none',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#6b7280',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#e5e7eb';
              e.target.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#f3f4f6';
              e.target.style.color = '#6b7280';
            }}
          >
            ×
          </button>
        </div>

        <h2
          style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#202223',
            margin: '0 0 8px 0',
            textAlign: 'center',
          }}
        >
          Add Home Category
        </h2>
        <p
          style={{
            textAlign: 'center',
            fontSize: '14px',
            color: '#6d7175',
            margin: '0 0 24px 0',
          }}
        >
          Create a new home category to organize your products
        </p>

        <div style={{ marginBottom: '24px' }}>
          <TextField
            fullWidth
            label="Category Name"
            placeholder="Enter category name"
            variant="outlined"
            onChange={(e) => setName(e.target.value)}
            onKeyPress={handleKeyPress}
            value={Name}
            autoFocus
            disabled={loading}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#008060',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#008060',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#008060',
              },
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              setOpenCategoryModal(false);
            }}
            disabled={loading}
            style={{
              color: '#6d7175',
              borderColor: '#c9cccf',
              textTransform: 'none',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '500',
              borderRadius: '8px',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              SubmitData();
            }}
            disabled={loading}
            style={{
              backgroundColor: loading ? '#ccc' : '#008060',
              color: 'white',
              textTransform: 'none',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '500',
              borderRadius: '8px',
              boxShadow: 'none',
            }}
          >
            {loading ? "Creating..." : "Create Category"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CategoryCreateSelectModal;